import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    previewUrl: String
  }

  previewFilledForm(event) {
    event.preventDefault()

    const form = event.target.closest('form')
    const formData = new FormData(form)

    // Get additional parameters from the button if present
    const additionalParams = event.params || {}

    // Add any additional parameters to form data
    Object.keys(additionalParams).forEach(key => {
      if (key !== 'previewUrl') {
        formData.append(key, additionalParams[key])
      }
    })

    const params = new URLSearchParams(formData)

    // Use the preview URL from the button's data attribute or the controller's value
    const previewUrl = event.params.previewUrl || this.previewUrlValue
    const fullUrl = previewUrl.includes('?') ? `${previewUrl}&${params.toString()}` : `${previewUrl}?${params.toString()}`

    window.open(fullUrl, '_blank', 'width=800,height=1000,scrollbars=yes')
  }
}
